import React from "react";

import { CardProps } from "./Card.types";
import "./Card.scss";

import Container from "../../atoms/Container/Container";
import VideoPlayer from "../VideoPlayer/VideoPlayer";

const Card: React.FC<CardProps> = ({
  title,
  mediaUrl,
  youTubeVideoId,
  children,
  theme = "blue",
  removePadding = false,
  titleSizeEM = 1.3,
}) => (
  <div className="mp-molecules-card--main">
    {title && (
      <div className={`header ${theme}`}>
        <h1 style={{ fontSize: `${titleSizeEM}em` }}>{title}</h1>
      </div>
    )}
    <div className={`header-line ${theme}`} />
    {mediaUrl && (
      <>
        {youTubeVideoId ? (
          <VideoPlayer
            thumbnailURL={mediaUrl}
            youTubeVideoID={youTubeVideoId}
          />
        ) : (
          <img src={mediaUrl} alt="card-media" />
        )}
      </>
    )}
    <>
      {removePadding ? (
        <>{children}</>
      ) : (
        <Container>
          <div>{children}</div>
        </Container>
      )}
    </>
  </div>
);

export default Card;
